import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteItemCategoriesDialog } from "./item-categories-delete-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { deleteItemCategoriesService } from "./item-categories-delete-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemCategoriesDelete = () => {
    const classes = useStyles();
    const itemCategoriesData = useSelector((state) => state.itemCategoriesDeleteSlice.itemCategoriesDelete);
    const showDialog = useSelector((state) => state.itemCategoriesDeleteSlice.showDialog);
    const isLoading = useSelector((state) => state.itemCategoriesDeleteSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    const itemCategoriesId = itemCategoriesData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            setFormData(itemCategoriesData);
        }
    }, [showDialog, itemCategoriesData]);

    // handle delete submit
    const handleDeleteSubmit = async (e) => {
        try {
            await deleteItemCategoriesService(dispatch, db, "item_categories", itemCategoriesId)
        } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to delete."));
            console.error("ItemCategoriesDelete handleDeleteSubmit error: ", e);
        }
        handleDeleteClose();
    };

    // handle close delete
    const handleDeleteClose = () => {
        dispatch(closeDeleteItemCategoriesDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Delete Item Categories
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.text}>
                    {`Do you want to delete '${formData?.code} - ${formData?.name}'?`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleDeleteSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Deleting..."
                        ) : (
                            "Delete"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleDeleteClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemCategoriesDelete;